import { ROUTE_CHANGE, PAGE_CHANGE, LINK_CLICK, TRACK_SEARCH } from './metricsConstants';

export const routeChange = location => {
  return {
    type: ROUTE_CHANGE,
    location,
  };
};

export const pageChange = data => {
  return dispatch => {
    dispatch({
      type: PAGE_CHANGE,
      data,
    });
  };
};

export const linkClick = data => {
  return dispatch => {
    dispatch({
      type: LINK_CLICK,
      data,
    });
  };
};

export const trackSearch = data => {
  return dispatch => {
    dispatch({
      type: TRACK_SEARCH,
      data,
    });
  };
};
